import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { useLoadingStore } from '../../store/loadingStore';

interface RefreshButtonProps {
  onRefresh: () => void;
  tooltip?: string;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onRefresh,
  tooltip = 'Actualizar',
  size = 'small',
  disabled = false
}) => {
  const { isPolling } = useLoadingStore();
  const location = useLocation();
  const isDisabled = disabled || isPolling;
  const iconSize = size === 'small' ? 'small' : 'medium';
  
  // Solo mostrar spinner si NO estamos en una ruta de licitación específica
  const isInLicitacionDetail = location.pathname.startsWith('/licitacion/');
  const shouldShowSpinner = isPolling && !isInLicitacionDetail;

  const button = (
    <IconButton
      onClick={onRefresh}
      disabled={isDisabled}
      size={size}
      sx={{
        color: '#585858',
        '&:hover': {
          color: '#0095FF',
          backgroundColor: 'rgba(0, 149, 255, 0.1)'
        },
        '&:disabled': {
          color: '#bdbdbd'
        }
      }}
    >
      {shouldShowSpinner ? (
        <CircularProgress 
          size={iconSize === 'small' ? 16 : 20} 
          sx={{ color: '#585858' }}
        />
      ) : (
        <RefreshIcon fontSize={iconSize} />
      )}
    </IconButton>
  );

  return (
    <Tooltip title={shouldShowSpinner ? 'Actualizando...' : tooltip} arrow>
      {isDisabled ? <span>{button}</span> : button}
    </Tooltip>
  );
};

export default RefreshButton; 